import { Component } from '@angular/core';
import { MenuController, NavController, NavParams } from 'ionic-angular';
import 'rxjs/add/observable/of';
import 'rxjs/add/observable/timer';
import 'rxjs/add/operator/delay';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/takeWhile';
import { Proband, Run, Session } from '../../data/data';
import { AudioProvider } from '../../provider/audio-service';
import { DataProvider } from '../../provider/data-service';
import { Settings, SettingsProvider } from '../../provider/settings-service';
import { SessionPage } from '../session/session';
import { History } from './../../data/data';
import { Circle } from './tap-canvas';

enum Runstatus {
    Prepare = 1,
    Running = 2,
    Stopped = 3
}

@Component({
    selector: 'page-mpt',
    templateUrl: 'mpt.html'
})
export class MPTPage {

    public settings: Settings;
    public history: History;

    public proband: Proband;
    public session: Session;
    public run: Run;

    public countdown = 0;
    public durchlauf = 1;
    public runstatus = Runstatus.Prepare;

    private t0: number;
    private tlast: number;

    public startAllowed = true;
    private timer: any;
    public enumRunstatus = Runstatus;

    constructor(
        public navCtrl: NavController,

        private menu: MenuController,
        private settingsProvider: SettingsProvider,
        private dataProvider: DataProvider,
        private navParams: NavParams,
        private audio: AudioProvider
    ) {
        this.settings = this.settingsProvider.settings;
        this.history = this.dataProvider.history;

        this.proband = this.navParams.get('proband');
        this.session = this.navParams.get('session');
    }

    public ionViewDidEnter() {
        this.menu.swipeEnable(false);
    }

    public ionViewWillLeave() {
        this.menu.swipeEnable(true);
        this.stopTimer();
    }

    public start(): void {
        this.countdown = this.settings.anschlaege;
        const rate = this.settings.rate;
        const t = 1 / rate * 1000;

        if (this.session) {
            this.run = this.session.newRun();
        } else {
            this.run = new Run();
        }

        this.run.startzeit = new Date();
        this.run.anschlaegeVorgabe = this.settings.anschlaege;
        this.run.anschlagrate = rate;

        this.startTimer(t);

        this.runstatus = Runstatus.Running;
        this.t0 = performance.now();
        this.tlast = this.t0;
    }

    private startTimer(intervall: number) {
        this.stopTimer();

        let start = Date.now(); // performance.now();
        let nextTime = intervall;
        let last = start
        let sum = 0

        this.timer = setInterval(() => {
            const now = Date.now(); // performance.now();
            const delta = now - start; // milliseconds elapsed since start
            if (delta >= nextTime) {
                nextTime += intervall

                let diff = now - last
                sum = sum + diff
                const debugText = diff + ', ' + sum;

                this.audio.ping(debugText);

                last = now;
            }
        }, 1);
    }

    private stopTimer() {
        if (this.timer) {
            clearInterval(this.timer);
            this.timer = null;
        }
    }

    public end(): void {
        this.stopTimer();
        this.runstatus = Runstatus.Stopped;
        this.save();

        setTimeout(() => {
            if (this.settings.durchlaeufe <= this.durchlauf) {
                this.return();
            } else {
                this.durchlauf++;
                this.runstatus = Runstatus.Prepare;
            }
        }, 2000);
    }

    public save(): void {
        this.dataProvider.save();
    }

    public return(): void {
        this.stopTimer();
        this.navCtrl.setRoot(SessionPage);
    }

    public hit(circle: Circle): void {
        if (this.runstatus === Runstatus.Running) {
            var tnow = performance.now();
            this.run.addAnschlag(this.t0, this.tlast, tnow, circle.nr);
            this.tlast = tnow;
            this.countdown--;
            if (this.countdown <= 0) {
                this.end();
            } else {
                // console.log(this.countdown);
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/pages/mpt/mpt.ts